var mentions_default = {
  "mentionPalette": "ghk6p",
  "mention": "_55xJz",
  "mentionViewer": "ZPXh0",
  "mentionSuggestionsEntry": "V2sMj",
  "mentionSuggestionsEntryFocused": "PC4p3",
  "mentionSuggestionsEntryText": "s-14i",
  "mentionSuggestionsEntryAvatar": "_9KzRb",
  "mentionSuggestions": "_6BaHH",
  "cursorDefault": "PaBHz",
  "cursorPointer": "Dkz1b"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
